// extracted by mini-css-extract-plugin
module.exports =  {"logo":"lIE2IRbHcCkAB62Q8sHb","arrow":"wmO4Xy99oTBTyLRQ12nz","recordLabel":"wXRKZ1zGylr8fZ7s27Ci"};